var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "595.281px",
    height: "396.85px",
    viewBox: "0 0 595.281 396.85",
    enableBackground: "new 0 0 595.281 396.85",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "key",
    fill: "#8DC63F",
    d: "M446.458,148.819H297.64l-22.323-29.764c-9.369-12.491-24.071-19.843-39.685-19.843h-49.606 c-27.396,0-49.605,22.208-49.606,49.604c0,0.001,0,0.001,0,0.002v86.813c0,27.396,22.208,49.604,49.604,49.604 c0.001,0,0.001,0,0.002,0h49.606c15.614,0,30.316-7.351,39.685-19.842l22.323-29.764h18.161l25.243-25.244l24.804,24.804 l24.805-24.804l24.803,24.804l24.803-24.804l16.912,16.913l26.494-20.605v-28.938L446.458,148.819z M210.829,210.826 c0,6.85-5.552,12.4-12.401,12.4h-12.402c-6.849,0-12.401-5.552-12.401-12.4v-37.204c0-6.851,5.552-12.402,12.401-12.402h12.402 c6.849,0,12.401,5.553,12.401,12.402V210.826L210.829,210.826z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.3cfdffa3abfd9a19c5a6c0036eec99e6.svg";
export { ForwardRef as ReactComponent };